import { helpers, sameAs } from "@vuelidate/validators";
import { computed } from "vue";

export const rules = computed(() => ({
    atleastOneSelected: {
        sameAs: helpers.withMessage("Please select a minimum of one type of stroke.",
            sameAs(true)),
    },
}));
